import { render, staticRenderFns } from "./AddFood.vue?vue&type=template&id=579564d2&scoped=true&"
import script from "./AddFood.vue?vue&type=script&lang=js&"
export * from "./AddFood.vue?vue&type=script&lang=js&"
import style0 from "./AddFood.vue?vue&type=style&index=0&id=579564d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579564d2",
  null
  
)

export default component.exports